import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import UpgradePopup from 'components/UpgradePopup';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import ProfileHeader from 'components/ProfileHeader';
import ProfileData from 'components/ProfileData';
import Footer from 'components/MiniFooter';
import TrialNotification from 'components/TrialNotification';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { logPageView, initGA } from 'utils/analytics';
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import { RegisterAthlete } from 'routes/routeNames';
import VideoPlayer from 'components/VideoPlayer';
import { getTotalCounts } from '../../components/DashboardView/actions';
import style from './Profile-view.scss';// to import local scss fle

import Session from './../../components/Session/';

import { selector } from './redux';
import { getSAProfile, saveUserImage, videoDetails, setCurrentVideo, removeVideo } from './actions';


class ProfileView extends Component {

  static propTypes = {
    attributes: PropTypes.shape(),
    profile: PropTypes.shape(),
    history: PropTypes.shape(),
    getSAProfile: PropTypes.func,
    requested: PropTypes.bool,
    isLoading: PropTypes.bool,
    subscribed: PropTypes.bool,
  };
  static defaultProps = {
    attributes: {},
    history: {},
    profile: Map(),
    getSAProfile: () => {},
    requested: false,
    isLoading: false,
    subscribed: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      showFullScreenVideo: false,
      videoOnProfile: false,
    };
    this.removeVideoScreen = this.removeVideoScreen.bind(this);
  }

  componentWillMount() {
    const { attributes, history } = this.props;
    if (attributes.size > 0) {
      const zoneinfo = attributes.get('zoneinfo');
      if (!(zoneinfo === 'STUDENT' || zoneinfo === 'ADMIN')) {
        history.push('/');
      }
    }
  }

  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line

    if (this.props.attributes && this.props.attributes.size > 0) {
      const saProfile = this.props.attributes.get('profile');
      if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
        this.props.getSAProfile(saProfile);
      } else {
        this.props.history.push(RegisterAthlete);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { attributes } = this.props;
    const { history } = nextProps;
    if (nextProps.attributes.size > 0) {
      const zoneinfo = nextProps.attributes.get('zoneinfo');
      if (!(zoneinfo === 'STUDENT' || zoneinfo === 'ADMIN')) {
        history.push('/');
      }
    }
    if (!this.props.requested && nextProps.attributes && !is(nextProps.attributes, attributes)) {
      const saProfile = nextProps.attributes.get('profile');
      if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
        this.props.getSAProfile(saProfile);
      } else {
        this.props.history.push(RegisterAthlete);
      }
    } else if (nextProps.profile.size > 0) {
      const saSports = nextProps.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);
      let profileImage = '';
            let primary_offensive_position_pref = ''; //eslint-disable-line
            let primary_defensive_position_pref = ''; //eslint-disable-line
            let secondary_offensive_position_pref = ''; //eslint-disable-line
            let secondary_defensive_position_pref = ''; //eslint-disable-line
            let special_teams = ''; //eslint-disable-line

      let sat = '';
      let act = '';
      if (nextProps.profile.get('profile_image') !== undefined) {
        profileImage = nextProps.profile.get('profile_image');
      } else {
        profileImage = '';
      }
      let instagramLink = '';
      if (nextProps.profile.get('sa_instagram')) {
        instagramLink = nextProps.profile.get('sa_instagram');
      } else {
        instagramLink = '';
      }
      let twitterLink = '';
      if (nextProps.profile.get('sa_twitter')) {
        twitterLink = nextProps.profile.get('sa_twitter');
      } else {
        twitterLink = '';
      }
      if (sport.get('primary_offensive_position_pref') !== undefined) {
                primary_offensive_position_pref = sport.get('primary_offensive_position_pref'); //eslint-disable-line
      } else {
                primary_offensive_position_pref = ''; //eslint-disable-line
      }
      if (sport.get('primary_defensive_position_pref') !== undefined) {
                primary_defensive_position_pref = sport.get('primary_defensive_position_pref'); //eslint-disable-line
      } else {
                primary_defensive_position_pref = ''; //eslint-disable-line
      }
      if (sport.get('secondary_offensive_position_pref') !== undefined) {
                secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref'); //eslint-disable-line
      } else {
                secondary_offensive_position_pref = ''; //eslint-disable-line
      }
      if (sport.get('secondary_defensive_position_pref') !== undefined) {
                secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref'); //eslint-disable-line
      } else {
                secondary_defensive_position_pref = ''; //eslint-disable-line
      }
      if (sport.get('special_teams') !== undefined) {
                special_teams = sport.get('special_teams'); //eslint-disable-line
      } else {
                special_teams = ''; //eslint-disable-line
      }
      const academic = nextProps.profile.get('academic');
      if (academic.get('sat') !== undefined) {
        sat = academic.get('sat');
      }
      if (academic.get('act') !== undefined) {
        act = academic.get('act');
      }


      const newState = {
                // profile
        gender: nextProps.profile.get('gender'),
        fullname: nextProps.profile.get('fullname'),
        state: nextProps.profile.get('sa_state'),
        city: nextProps.profile.get('city'),

                // sports
        height: nextProps.profile.get('height'),
        weight: nextProps.profile.get('weight'),
        sportName: keys[0],
        t40: sport.get('t40'),
        bench: sport.get('bench'),
        squats: sport.get('squats'),
        description: sport.get('description'),

        primary_offensive_position_pref,
        primary_defensive_position_pref,
        secondary_offensive_position_pref,
        secondary_defensive_position_pref,
        special_teams,
                // school
        school: nextProps.profile.get('school'),
        year_of_graduation: academic.get('year_of_graduation'),
        gpa: academic.get('gpa'),
        sat,
        act,
        profileId: nextProps.profile.get('id'),
        video: nextProps.profile.get('video_items').toJS(),
        profile_image: profileImage,
        instagram: instagramLink,
        twitter: twitterLink,
        evaluationText: nextProps.profile.get('evaluation_text'),
      };
      this.setState(newState);
    }
  }

  removeVideoScreen() {
    this.setState({ showFullScreenVideo: !this.state.showFullScreenVideo });
  }

  render() {
    const { profile, isLoading, subscribed } = this.props;
    const renderIfProfile = renderIf(profile.size > 0);
    const renderIfLoading = renderIf(isLoading);
    const renderVideoPlayer = renderIf(this.state.showFullScreenVideo);
    let renderPopup = true;
    if (profile.get('payment_info') !== undefined && subscribed) {
      renderPopup = false;
    }
    let showTrialButton = false;
    if (this.props.profile.get('trialEndDate') === undefined && this.props.profile.get('payment_info') === undefined) {
      showTrialButton = true;
    }
    let onTrial = false;
    if (this.props.profile !== undefined) {
      if (this.props.profile.get('trialEndDate')) {
        onTrial = moment().isBefore(this.props.profile.get('trialEndDate'));
      }
    }
    const renderUpgradePopup = renderIf(renderPopup);
    return (
      <div>
        {renderIfLoading(
          <FullScreenLoader />,
          )}
        {renderUpgradePopup(
          <UpgradePopup {...this.props} usedFor="profile_page" showTrialButton={showTrialButton} onTrial={onTrial} />,
         )}
        {renderIfProfile(
          <div className={cn('row', style.profileContainer)} >
            {(!subscribed && onTrial) && <TrialNotification trialEndDate={this.props.profile.get('trialEndDate')} />}
            <ProfileHeader {...this.props} {...this.state} page="athleteView" navBarUsedBy="athlete" onTrial={onTrial} />
            <ProfileData
              removeVideoScreen={this.removeVideoScreen}
              {...this.props}
              {...this.state}
            />
            <Footer />
          </div>,
        )}
        {renderVideoPlayer(
          <VideoPlayer
            removeVideoScreen={this.removeVideoScreen}
            showVideo={this.state.showFullScreenVideo}
            {...this.props}
          />,
          )}

      </div>
    );
  }
}


export default connect(selector,
  { getSAProfile,
    saveUserImage,
    videoDetails,
    setCurrentVideo,
    getTotalCounts,
    removeVideo,
  })(Session(ProfileView));



// WEBPACK FOOTER //
// ./src/containers/Profile-view/Profile-view.js